<div class="row">
  <div class="col-sm-12">
    <h3 class="sub-title alert alert-info text center">Drill Skill  </h3></div>
  <div class="col-sm-12 text-end alert">
      <a [routerLink]="['/admin/drill_skills/show',0]" class ="btn btn-primary"> <i class="fa fa-plus"></i> Add New Drill Skill</a>
  </div>
</div>
<div class="table-responsive" *ngIf="drillSkillList.length>0">
<span [appMath]="''"></span>
<table  datatable [dtOptions]="dtOptions" class="table table-striped display compact">
  <thead>
  <tr>
  <th>Name</th>
  <th>SkillCode</th>
  <th>Description</th>
  <th>Configuration</th>
  <th></th>

  </tr>
  </thead>

  <tbody>

  <tr *ngFor="let drillSkill of drillSkillList;">
    <td>{{drillSkill.name}}</td>
     <td>{{drillSkill.skillCode}}</td>
     <td><a [routerLink]="['/admin/fact/show',drillSkill.server_drill_skill_id]">
         {{drillSkill.description}}
      </a>
      </td>
      <td>{{drillSkill.configuration}}</td>
      <td></td>
  </tr>

  </tbody>

</table>

</div>

<app-spinner *ngIf="(drillSkillList.length==0) && loading"></app-spinner>
<div *ngIf="(drillSkillList.length==0) && !loading" class="text-center">No Records Found </div>

<hr/>
<div class="text-center">

</div>
